import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Switch,
} from "@mui/material";
import ColorIndicator from "components/common/color_indicator/ColorIndicator";
import { Add as AddIcon } from "@mui/icons-material";
import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

const RpmTableToolbar = ({
  changeSchedule,
  changeRpmFilter,
  table,
  openEnrollModal,
}) => {
  const navigate = useNavigate();

  const { currentUser } = useSelector((state) => state.auth);

  const [isFilters, setIsFilters] = useState(false);
  const [activeTransmissions, setActiveTransmissions] = useState(false);
  const [lateTransmissions, setLateTransmissions] = useState(false);

  useEffect(() => {
    changeRpmFilter(isFilters);
  }, [isFilters]);

  useEffect(() => {
    changeSchedule(
      activeTransmissions && lateTransmissions ? "and" : "or",
      activeTransmissions,
      lateTransmissions
    );
  }, [activeTransmissions, lateTransmissions]);

  return (
    <div
      className="d-flex justify-between"
      style={{
        padding: "10px",
        borderBottom: "1px solid #e0e0e0",
        marginBottom: "20px",
      }}
    >
      <div className="d-flex align-items-center" style={{ gap: 15 }}>
        <GlobalFilterTextField table={table} />
        <Button
          onClick={() => openEnrollModal(true)}
          variant="contained"
          color="secondary"
          startIcon={<AddIcon />}
        >
          Enroll New Patient
        </Button>

        {currentUser?.clinii_user_id && (
          <Button
            onClick={() => navigate("/rpm")}
            variant="text"
            color="secondary"
          >
            Go to New RPM Interface
          </Button>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "24px",
        }}
      >
        <FormControlLabel
          style={{ margin: 0 }}
          control={
            <Switch
              onChange={(_event, checked) => setIsFilters(checked)}
              checked={isFilters}
              name={"isFilters"}
            />
          }
          label={"Filters"}
          labelPlacement="start"
        />
        <FormControlLabel
          style={{ margin: 0 }}
          control={
            <Checkbox
              onChange={(_event, checked) => setActiveTransmissions(checked)}
              checked={activeTransmissions}
              name="activeTransmissions"
            />
          }
          label="Active Transmissions"
        />

        <FormControlLabel
          style={{ margin: 0 }}
          control={
            <Checkbox
              onChange={(_event, checked) => setLateTransmissions(checked)}
              checked={lateTransmissions}
              name="lateTransmissions"
            />
          }
          label="Late Transmissions"
        />
        <Divider orientation="vertical" variant="middle" className="divider" />
        <div className="d-flex flex-column">
          <ColorIndicator
            index={0}
            color="rgba(239, 83, 80)"
            label="Signal Strength < 50"
          />
          <ColorIndicator
            index={1}
            color="rgba(76, 175, 80)"
            label="Signal Strength &ge; 50"
          />
        </div>
      </div>
    </div>
  );
};

export default RpmTableToolbar;
